import React from "react";
import { Button, Text, type AgGrid } from "@jsq/ds/core";
import { type CashTransactionRowItem } from "../types";

export type EntityCellParams = AgGrid.ICellRendererParams<CashTransactionRowItem> & {
  onEntityClick?: (transaction: CashTransactionRowItem) => void;
};

/**
 * Entity cell. Renders as a link via the DS `Button`'s `link` variant when
 * `onEntityClick` is supplied; otherwise plain (non-interactive) text —
 * without a handler there's nothing for a clickable control to do.
 */
export const EntityCell: React.FC<EntityCellParams> = ({ data, onEntityClick }) => {
  if (!data) return null;
  const { entityName } = data;

  if (!onEntityClick) {
    return <Text asSpan>{entityName}</Text>;
  }

  return (
    <Button variant="link" displayAsLink isInline onClick={() => onEntityClick(data)}>
      {entityName}
    </Button>
  );
};

export default EntityCell;
